module.exports = "<span class=\"palatinoFont\">SEC<span class=\"controlForThree\">3</span>URE</span>\n"